import classes from './VideoRewrite.module.less';
import { useEffect, useRef, useState } from 'react';
import Icon from '@/components/iconfont/Icon';
import message from '@/utils/message';
import Upload from './Upload';
import YoutubeImg from '@/assets/vidtranslate/youto.png';
import Confirm from '@/components/confirm/Confirm';
import SyncSelectedImg from '@/assets/vidtranslate/syncSelected.svg';
import { useTranslation } from 'react-i18next';
import { useDrawer } from '@/hooks/DrawerHooks';
import { useDashboardData } from '@/hooks/DashboardHooks';
import { EseClosePopup } from '@/hooks/useClosePopup';
import { createProject, createYoutube } from '@/api/upload.js';
import './VideoRewrite.less';
import { vidTranslation } from '@/api';
const targetLanguageList = [
  { id: 0, name: 'English', language: 'English' },
  { id: 1, name: 'French', language: 'Français' },
  { id: 2, name: 'Spanish', language: 'Español' },
  { id: 4, name: 'German', language: 'Deutsch' },
  { id: 5, name: 'Arabic', language: 'العربية' },
  { id: 14, name: 'Japanese', language: '日本語' },
  { id: 15, name: 'Chinese', language: '中文' },
  { id: 16, name: 'Korean', language: '한국어' },
];
import ChooseLanguage from '@/components/chooseLanguage/ChooseLanguage.jsx';
const Panel = ({ show, onClose, onUpload, projectType, onCreateSuccess }) => {
  // projectType: 0 重写 , 1 旁白
  const { setIsOpen } = useDrawer();
  const {
    userData,
    pointConsume,
    youtobeCreateProject,
    languageList: defaultLanguage,
  } = useDashboardData();
  const modalRef = useRef(null);
  const [file, setFile] = useState();
  const [duration, setDuration] = useState({ current: 0 });
  const [url, setUrl] = useState('');
  const [voice, setVoice] = useState(false);
  const [showVoiceConfirm, setShowVoiceConfirm] = useState(false);
  const [tab, setTab] = useState(0); // 0 for Upload, 1 for Youtube
  const [youtubeUrl, setYoutubeUrl] = useState('');
  const [youtubeError, setYoutubeError] = useState(false);
  const [startUpload, setStartUpload] = useState(true);
  const [successUpload, setSuccessUpload] = useState(false);
  const [resetUpload, setResetUpload] = useState(false);
  const [videoMinutes, setVideoMinutes] = useState(0);
  const { t } = useTranslation();
  const [stream, setStream] = useState();
  const [thumbnail, setThumbnail] = useState();
  const [showTargetLanguage, setShowTargetLanguage] = useState(false);
  const [createPerjectLoading, setCreatePerjectLoading] = useState(false);
  // const [createYoutoLoading, setCreateYoutoLoading] = useState(false);
  const [targetLanguage, setTargetLanguage] = useState(targetLanguageList[0]);
  const [youtoLoading, setYoutoLoading] = useState(false);
  const [fileVideoMinutes, setFileVideoMinutes] = useState(0);
  const inputRef = useRef(null);
  const videoTime = useRef({ fileTime: 0, urlTime: 0 });
  const [playUrl, setPlayUrl] = useState('');
  const [uploadInstanceProps, setUploadInstanceProps] = useState(null);
  const [youtubeImg, setyoutubeImg] = useState('');
  const [youtubeTempId, setYoutubeTempId] = useState('');
  const [isClosePop, setIsClosePop] = useState(false);
  const handleTargetLanguage = (val) => {
    setTargetLanguage(val);
  };
  useEffect(() => {
    if (show) {
      setDefaultLanguage();
      modalRef.current?.show();
      setStartUpload(true);
    } else {
      modalRef.current?.close();
      console.log('执行到这里');
      reset();
      if (uploadInstanceProps) {
        uploadInstanceProps.stop();
      }

      setSuccessUpload(false);
    }
  }, [show]);

  useEffect(() => {
    inputRef.current && inputRef.current.focus();
  }, [tab]);

  const setDefaultLanguage = () => {
    const languageCode = localStorage.getItem('i18nextLng') || 'en-US';
    const { originalLanguage } = defaultLanguage.find((res) => res.code.includes(languageCode));
    const original = targetLanguageList.find((res) => res.name === originalLanguage);
    if (original) {
      setTargetLanguage(original);
    }
  };
  const changeTab = (tab) => {
    if (tab === 0) {
      window.onClickGATrackEvent(
        projectType ? 'addnarration-select-upload' : 'rewrite-select-upload',
      );
    } else {
      window.onClickGATrackEvent(projectType ? 'addnarration-select-url' : 'rewrite-select-url');
    }
    // if (createPerjectLoading) return;
    setTab(tab);
    setVideoMinutes(0);
    tab === 1 && youtubeUrl && validateUrl();
    // setFile(undefined);
    // setYoutubeUrl('');
    // setSuccessUpload(false);
  };
  // 子组件传来的实例
  const getUploadInstance = (props) => {
    setUploadInstanceProps(props);
  };
  const reset = () => {
    if (url) {
      URL.revokeObjectURL(url);
    }

    setTab(0);
    setFile(undefined);
    setVoice(false);
    setUrl('');
    setYoutubeUrl('');
    setYoutubeError(false);
    setResetUpload(true);
    setCreatePerjectLoading(false);
    // setCreateYoutoLoading(false);
    setVideoMinutes(0);
    setTargetLanguage(targetLanguageList[0]);
    setFileVideoMinutes(0);
  };

  const handleYoutubeUrlChanged = (e) => {
    setYoutubeError(false);
    setVideoMinutes(0);
    setYoutubeUrl(e.target.value);
  };

  const handleVoiceChanged = () => {
    if (voice) {
      setVoice(false);
    } else {
      setShowVoiceConfirm(true);
    }
  };

  const confirmVoice = () => {
    setVoice(true);
  };

  const cancelVoice = () => {};

  const handleUploadSuccess = (stream, thumbnail, duration) => {
    setSuccessUpload(true);
    setStream(stream || undefined);
    setThumbnail(thumbnail || undefined);
    setDuration(duration);
  };

  const getTotalMinutes = (time) => {
    setFileVideoMinutes(Math.ceil(time / 60));
    videoTime.current.fileTime = Math.round(time);
    sendBuryPoint(Math.ceil(time / 60), 0);
  };

  const invalidYouTubeProjectSubmit = () => {
    if (!youtubeUrl.includes('youtube.com')) {
      setYoutubeError(true);
      return;
    }

    message.info(`${t('As_Home_Soon')}\n${t('As_Home_Soon2')}`, {
      position: 'center',
    });
  };
  const validYouTubeProjectSubmit = async () => {
    if (youtoLoading || createPerjectLoading) return;
    const obj = {
      type: 3, // 增加type =3  上传youtube链接
      name: 'YouTube Project',
      usage: projectType ? 3 : 0, // 3旁边 0重写
      youtubeUrl: youtubeUrl || '', // youtube链接
      language: targetLanguage?.name || '', // 原始语言（翻译项目需要传入）
      generateSpeech: false, // 是否TTS
      useTranslate: false, // 是否翻译
      mode: projectType ? 'narration' : 'rewrite',
      imgUrl: youtubeImg, //临时数据，用来在项目列表展示封面图
      tempId: youtubeTempId, // 临时id 用来替换真实id
    };
    if (projectType) {
      delete obj.generateSpeech;
      delete obj.useTranslate;
      delete obj.language;
    }
    // setCreateYoutoLoading(true);
    onUpload(obj);
    onClose();
    setSuccessUpload(false);
    try {
      const res = await createYoutube(obj);
      if (res.code === 0) {
        onCreateSuccess(res.data);
      }
    } catch (e) {
      console.log(e);
    }
    // setCreateYoutoLoading(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const selectTarget = document.querySelector('.rewrite_select_target');
      if (selectTarget && !selectTarget.contains(event.target)) {
        setShowTargetLanguage(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const sendBuryPoint = (time, type) => {
    const stats = canRewrite(time);
    if (!stats) {
      window.onClickGATrackEvent(
        projectType ? 'addnarration-need-upgrade' : 'rewrite-need-upgrade',
        {
          video_duration: type === 0 ? time || fileVideoMinutes : time || videoMinutes,
          video_type: type === 0 ? 'file' : 'url',
        },
      );
    }
  };
  const canRewrite = (val = 0) => {
    const type = projectType ? 'narration' : 'rewrite';
    const consume = pointConsume?.filter((res) => res.mode === type);
    const time = tab === 0 ? fileVideoMinutes : videoMinutes;
    const needCredits = (val || time) * consume[0]?.number;
    const user_credits = userData?.actualTotalPoints || 0;
    return user_credits >= needCredits;
  };
  const formatMinutes = (milliseconds) => {
    if (!milliseconds) return 0;
    const minutes = milliseconds / 60000;
    return minutes % 1 === 0 ? minutes : Math.ceil(minutes);
  };
  async function validateUrl() {
    // 判断是否使用youtobe创建项目
    if (!youtobeCreateProject) {
      const state = youtubeUrl.includes('youtube.com');
      !state && setYoutubeError(true);
      setVideoMinutes(state ? 0.01 : 0);
      return state;
    }
    const urlRegex = /^https?:\/\/.+/;
    if (!youtubeUrl) {
      setVideoMinutes(0);
      return false;
    }
    if (urlRegex.test(youtubeUrl)) {
      // console.log(youtobeCreateProject, 'youtobeCreateProject');
      setYoutoLoading(true);
      let url_valid = false;
      try {
        const res = await vidTranslation.youtubeVideo({
          url: youtubeUrl,
        });
        if (res) {
          setVideoMinutes(formatMinutes(res.data.duration));
          videoTime.current.urlTime = Math.round(res.data.duration / 1000);
          sendBuryPoint(formatMinutes(res.data.duration), 1);
          setyoutubeImg(res.data?.image?.medium?.url);
          setYoutubeTempId(res.timestamp + Date.now());
          url_valid = true;
        } else {
          throw new Error('url error');
        }
      } catch (error) {
        setVideoMinutes(0);
        setYoutubeError(true);
        console.log(error);
      }
      window.onClickGATrackEvent(
        projectType ? 'addnarration-url-processed' : 'rewrite-url-processed',
        { url_valid },
      );
      setYoutoLoading(false);
    } else {
      setVideoMinutes(0);
      setYoutubeError(true);
    }
  }
  const handleCreateProject = async () => {
    if (createPerjectLoading) return;
    setCreatePerjectLoading(true);
    window.onClickGATrackEvent(projectType ? 'addnarration-submit' : 'rewrite-submit', {
      video_type: 'file',
      source_lan: targetLanguage?.name,
    });
    try {
      const obj = {
        name: file?.name.split('.').slice(0, -1).join('.'),
        duration: duration?.current || 0,
        language: targetLanguage?.name,
        thumbnailUpload: {
          uploadId: thumbnail?.uploadId || '',
          completedParts: thumbnail?.eTags,
        },
        streams: [
          {
            upload: {
              uploadId: stream?.uploadId,
              completedParts: stream?.eTags,
            },
            type: 1,
            zIndex: 1,
          },
        ],
        type: 1,
        usage: projectType ? 3 : 0, // 3旁边 0重写
        cloneVoice: true,
        mode: projectType ? 'narration' : 'rewrite',
        imgUrl: playUrl, //临时数据，用来在项目列表展示封面图
        tempId: stream?.uploadId + Date.now(), // 临时id 用来替换真实id
      };
      if (projectType) {
        delete obj.cloneVoice;
        delete obj.language;
      }
      onUpload(obj);
      onClose();
      setSuccessUpload(false);
      const res = await createProject(obj);
      if (res.code === 0) {
        // onUpload();
        // onClose();
        // setSuccessUpload(false);
        onCreateSuccess(res.data);
      } else {
        throw new Error(res.msg);
      }
    } catch (error) {
      console.log(error);
      message.error(t('As_CreateProjectRewrite_ErrorCreate'), {
        id: 'upload-video-project-failed',
      });
      setStartUpload(false);
    }
    setCreatePerjectLoading(false);
  };

  return (
    <div className={classes.panel}>
      {!isClosePop && <EseClosePopup close={onClose} />}
      <dialog ref={modalRef} className="modal infoPopup">
        <section>
          {!isClosePop && (
            <form method="dialog">
              <button
                className={`btn btn-sm btn-circle btn-ghost absolute`}
                style={{ top: '30px', right: '37px' }}
                onClick={onClose}>
                <Icon name="icon-close-stroke" style={{ color: '#242424', fontWeight: 'normal' }} />
              </button>
            </form>
          )}
          {isClosePop && (
            <button
              className={`btn btn-sm btn-circle btn-ghost absolute`}
              style={{ top: '30px', right: '37px' }}>
              <Icon name="icon-close-stroke" style={{ color: '#242424', fontWeight: 'normal' }} />
            </button>
          )}
          <h3>
            {projectType ? t('As_Edit_CreateProjChoice4') : t('As_CreateProjectRewrite_Title')}
          </h3>
          <ul className={classes.tabs}>
            <li className={tab === 0 ? classes.selected : ''} onClick={() => changeTab(0)}>
              <Icon name="icon-upload" />
              {t('As_Home_LocalFile334')}
            </li>
            <li className={tab === 1 ? classes.selected : ''} onClick={() => changeTab(1)}>
              <Icon name="icon-Youtube" />
              {t('As_Home_YoutubeLink334')}
            </li>
          </ul>
          {/* {tab === 0 ? ( */}
          <main className={classes.uploadMain} style={{ display: tab === 0 ? 'block' : 'none' }}>
            {show && (
              <Upload
                value={{
                  cloneVoice: voice,
                  reset: resetUpload,
                  startUpload,
                  projectType,
                  onImageBlob: (url) => {
                    setPlayUrl(url);
                  },
                  onFileChange: (file) => {
                    setFile(file);

                    setSuccessUpload(false);
                  },
                  onSuccess: handleUploadSuccess,
                  getTotalMinutes: getTotalMinutes,
                  getUploadInstance: getUploadInstance,
                  changePopUpClose: (data) => {
                    setIsClosePop(data);
                  },
                }}
              />
            )}
          </main>
          {/* ) : ( */}
          <main className={classes.youtubeMain} style={{ display: tab !== 0 ? 'block' : 'none' }}>
            <label
              className={`input youtobe_box flex items-center gap-2 ${youtubeError ? 'input-error' : ''}`}>
              <img src={YoutubeImg} alt="" />
              <div className="line"></div>
              <input
                ref={inputRef}
                type="text"
                className="grow"
                placeholder="https://www.youtube.com/watch?v=xxxxxx"
                value={youtubeUrl}
                onChange={handleYoutubeUrlChanged}
                onBlur={validateUrl}
                autoFocus
              />

              <div className="loading_box1">
                {youtoLoading && (
                  <span className="loading loading-spinner loading-sm ytbLoading"></span>
                )}
              </div>
            </label>
            <span style={{ visibility: youtubeError ? 'visible' : 'hidden' }}>
              {t('As_CreateProjectRewrite_ErrorYoutubeLink')}
            </span>
          </main>
          {/* )} */}
          {!projectType && (
            <div className={`info_box rewrite_target_language`}>
              <div className="text">{t('As_Edit_Tsln&SubtLangchoice1')}</div>
              <div
                className={`select_box rewrite_select_target ${showTargetLanguage && 'select_action'}`}>
                <div
                  className={`select_click_mask ${showTargetLanguage && 'select_click_mask_active'}`}
                  onClick={() => {
                    setShowTargetLanguage(!showTargetLanguage);
                  }}></div>
                <div className="select_value">
                  <div className="text">{targetLanguage?.language}</div>
                  <Icon name={showTargetLanguage ? 'icon-arrow-left' : 'icon-arrow-down'} />
                </div>
                {showTargetLanguage && (
                  <div className="select_list choose_language">
                    <ChooseLanguage
                      languageList={targetLanguageList}
                      language_action={targetLanguage}
                      onChang={(item) => {
                        handleTargetLanguage(item);
                        setShowTargetLanguage(!showTargetLanguage);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
          <ul className={classes.options}>
            <li>
              <label className="label cursor-pointer">
                <span className="label-text">{t('As_CreateProjectRewrite_Clone')}</span>
                <input
                  type="checkbox"
                  className="toggle toggle-primary"
                  checked={voice}
                  onChange={handleVoiceChanged}
                />
              </label>
            </li>
          </ul>
          <div className={classes.actions}>
            {!canRewrite() ? (
              <button
                className="btn btn-warning btn_upgrade btn_item"
                onClick={() => {
                  window.onClickGATrackEvent(
                    projectType ? 'addnarration-click-upgrade' : 'rewrite-click-upgrade',
                  );
                  setIsOpen(true);
                }}>
                {t('As_Recording_Upgrade')}
              </button>
            ) : tab === 0 ? (
              <button
                className="btn btn-primary btn_item"
                disabled={!successUpload}
                onClick={handleCreateProject}>
                {/*{createPerjectLoading && <span className="loading"></span>}*/}
                {t('As_CreateProjectRewrite_Button')}
              </button>
            ) : (
              <button
                className="btn btn-primary btn_item"
                disabled={!youtubeUrl || videoMinutes <= 0}
                onClick={() => {
                  window.onClickGATrackEvent(
                    projectType ? 'addnarration-submit' : 'rewrite-submit',
                    {
                      video_type: 'url',
                      source_lan: targetLanguage?.name,
                    },
                  );
                  youtobeCreateProject
                    ? validYouTubeProjectSubmit()
                    : invalidYouTubeProjectSubmit();
                }}>
                {/*{createYoutoLoading && <span className="loading"></span>}*/}
                {t('As_CreateProjectRewrite_Button')}
              </button>
            )}
          </div>
        </section>
      </dialog>
      <Confirm
        show={showVoiceConfirm}
        showClose={false}
        title={
          <img
            src={SyncSelectedImg}
            style={{ display: 'inline-block', marginTop: '20px' }}
            alt=""
          />
        }
        content={
          <span>
            The generation speed is slow after
            <br /> voice clone is selected
          </span>
        }
        okText="Confirm"
        okIsRight={false}
        okIsPrimary={false}
        cancelText="Cancel"
        cancelIsPrimary={true}
        onConfirm={confirmVoice}
        onCancel={cancelVoice}
        onClose={() => setShowVoiceConfirm(false)}
      />
    </div>
  );
};

export default function VideoRewrite({ show, onClose, onUpload, projectType, onCreateSuccess }) {
  const [showTab, setShowTab] = useState(false);

  useEffect(() => {
    setShowTab(show);
  }, [show]);

  const handleUpload = (val) => {
    onUpload(val);
    onClose();
  };

  return (
    <>
      <Panel
        show={showTab}
        onCreateSuccess={onCreateSuccess}
        onClose={onClose}
        onUpload={handleUpload}
        projectType={projectType}
      />
    </>
  );
}
